import { render, staticRenderFns } from "./AjaxButton.vue?vue&type=template&id=2f329cc4&"
import script from "./AjaxButton.vue?vue&type=script&lang=js&"
export * from "./AjaxButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports